import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { ServiceForm } from 'components/Forms';
import ServiceSuccess from 'containers/Landing/ServiceSuccess';
import ContentfulFields from 'components/ContentfulFields';
import { Container } from 'components/Ui';
import styles from './styles.scss';

class CoffeeService extends PureComponent {
  state = {
    submitted: false,
  };

  handleSubmit = () => {
    this.setState({ submitted: true });
  };

  render() {
    const {
      site: {
        components: { page },
      },
    } = this.props;
    const { submitted } = this.state;

    return (
      <Fragment>
        {page &&
          page.contentModules.map((banner) => (
            <ContentfulFields
              type={get(banner, 'sys.contentType.sys.id')}
              document={banner}
              key={banner.sys.id}
            />
          ))}
        <Container value="Coffee Service" className={styles.container}>
          {submitted ? (
            <ServiceSuccess />
          ) : (
            <ServiceForm
              handleSubmit={this.handleSubmit}
              url="water-coffee-service"
            />
          )}
        </Container>
      </Fragment>
    );
  }
}

CoffeeService.propTypes = {
  site: PropTypes.object,
};

export default CoffeeService;
